import { FileInput, FileUploader, FileUploaderContent, FileUploaderItem } from '@/components/shadcn/file-uploader'
import { IconUploadOutline } from '@icons/IconUploadOutline'
import { IconArrowDownOutline } from '@icons/IconArrowDownOutline'
import { IconDocumentFileOutline } from '@icons/IconDocumentFileOutline'
import { useState } from 'react'
import { DropzoneOptions } from 'react-dropzone'
import clsx from 'clsx'

type SyncFileUploaderProps = {
  files: File[]
  onFilesChange: (files: File[]) => void
}

export function SyncFileUploader({ files, onFilesChange }: SyncFileUploaderProps) {
  const [dragging, setDragging] = useState(false)

  const dropZoneConfig: DropzoneOptions = {
    accept: {
      'application/json': ['.json'],
    },
    maxFiles: 1,
    maxSize: 10 * 1024 * 1024, // 10MB
    multiple: false,
    onDragEnter: () => setDragging(true),
    onDragLeave: () => setDragging(false),
    onDrop: () => setDragging(false),
  }

  const handleFilesChange = (newFiles: File[] | null) => {
    onFilesChange(newFiles ?? [])
  }

  return (
    <FileUploader
      value={files}
      onValueChange={handleFilesChange}
      dropzoneOptions={dropZoneConfig}
      className="relative space-y-1"
    >
      <FileInput
        className={clsx('border border-dashed border-gray-500', {
          'border-solid border-primary bg-primary/10': dragging,
          hidden: files.length > 0,
        })}
      >
        <div className="flex w-full flex-col items-center justify-center gap-y-5 pb-4 pt-3">
          <IconUploadOutline className={clsx('size-7 text-muted', { hidden: dragging })} />
          <IconArrowDownOutline className={clsx('size-7 text-primary', { hidden: !dragging })} />
          <p className="text-sm">
            {dragging ? 'Drop JSON file' : 'Click to select or drag and drop a JSON file to import'}
          </p>
        </div>
      </FileInput>
      <FileUploaderContent>
        {files.map((file, i) => (
          <FileUploaderItem key={i} index={i}>
            <div className="flex items-center gap-x-2">
              <IconDocumentFileOutline className="mr-1 inline-block size-4" />
              <span className="max-w-md truncate font-light italic text-primary">{file.name}</span>
            </div>
          </FileUploaderItem>
        ))}
      </FileUploaderContent>
    </FileUploader>
  )
}
